<template>
	<!-- 监考管理 列表页 -->
	<div class="board">
		<div v-hasPermi="['invigilate:list']">
			<div class="title">
				<span class="name">{{ invigilateTextConfig.title }}</span>
			</div>
			<el-form :inline="true" :model="form" ref="form">
				<el-form-item>
					<el-select v-model="form.examPlanId" filterable clearable :placeholder="searchTextConfig.examPlan">
						<el-option v-for="(item, index) in examPlanOptions" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="form.subjectId" filterable clearable :placeholder="searchTextConfig.subjectId">
						<el-option v-for="(item,index) in subjectOptions" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
					<el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="tableData" border v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading" ref="multipleTable" stripe size="medium" :height="height" style="width:100%">
				<el-table-column prop="exam.examPlan.name" :label="tableTextConfig.examPlanName" min-width="220px" show-overflow-tooltip></el-table-column>
				<el-table-column prop="exam.subject" :label="tableTextConfig.subject" min-width="280px" show-overflow-tooltip></el-table-column>
				<el-table-column prop="examTime" :label="tableTextConfig.examTime" :formatter="examTimeFormatter" width="300px" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="exam.examineeCount" :label="tableTextConfig.examineeCount" width="100px" align="center"></el-table-column>
				<el-table-column prop="sheetCount" :label="tableTextConfig.sheetCount" width="100px" align="center"></el-table-column>
				<el-table-column prop="remarkAccount" :label="tableTextConfig.remarkAccount" width="100px" align="center"></el-table-column>
				<el-table-column fixed="right" :label="tableTextConfig.operate" align="center" width="120px">
					<template slot-scope="scope">
						<el-button v-hasPermi="['invigilate:detail:list']" plain type="primary" size="mini" @click="toInvigilateDetail(scope.row)">
							{{ tableTextConfig.button.details.name }}
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="tableData.length" :currentPage.sync="form.pageNumber" :pageSize.sync="form.pageSize" :total.sync="total"></pagination>
		</div>
	</div>
</template>

<script>

    import pagination from '@/components/pagination/pagination.vue'
    import {getDict} from "@/api/dict"
    import {getRecordList} from "@/api/invigilate";

    export default {
        components: {
            pagination
        },
        data() {
            return {
                height: 250,
                loading: true,
                form: {
                    examPaperId: '',
                    examPlanId: '',
                    reviewStatus: '',
                    subjectId: '',
                    pageNumber: 1,
                    pageSize: 20
                },
                total: 0,
                examPlanOptions: [],
                subjectOptions: [],
                tableData: [],
                specialDialogVisible: false,
                exportDialogVisible: false,
                row: null,
            }
        },
        computed: {
            invigilateTextConfig() {
                return this.$store.state.global.textConfig.backend.invigilate
            },
            searchTextConfig() {
                return this.invigilateTextConfig.search
            },
            tableTextConfig() {
                return this.invigilateTextConfig.table
            }
        },
        watch: {
            tableData() {
                if (this.tableData.length == 0) {
                    this.height = 120
                } else {
                    this.updateHeight()
                }
            }
        },
        beforeRouteEnter(to, from, next) {
            if (from.name === 'invigilateDetail') {
                to.meta.isBack = true
            } else {
                to.meta.isBack = false
            }
            next()
        },
        activated() {
            if (!this.$route.meta.isBack) {
                this.reset()
            } else {
                this.$route.meta.isBack = false
                // this.getBorrowList() /*列表重新加载*/
            }
        },
        created() {
            this.$store.dispatch("getExamPlan").then(res => {
                this.examPlanOptions = res.data
            });
            this.$store.dispatch("getExamSubject").then(res => {
                this.subjectOptions = res.data
            });
            this.search(1)
        },
        mounted() {
            const that = this;
            setTimeout(() => {
                that.updateHeight()
            }, 200);
            window.onresize = () => {
                that.updateHeight()
            };
        },
        methods: {
            search(val) {
                this.loading = true
                if (val) {
                    this.form.pageNumber = val
                }
                getRecordList(this.form).then(res => {
                    if (res.status == 200) {
                        this.tableData = res.data.list
                        this.total = res.data.total
                    }

                    this.loading = false
                    this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
                }).catch((err) => {
                    this.loading = false;
                })
            },
            reset() {
                this.form = this.$options.data().form
                this.form.pageSize = 20
                this.search(1)
            },
            updateHeight() {
                if (document.getElementsByClassName('el-form')[0]) {
                    this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 150
                    this.height = this.height < 460 ? 460 : this.height
                }
            },
            examTimeFormatter(row) {
                return row.exam.startTime + " ~ " + row.exam.endTime
            },
            toInvigilateDetail(data) {
                localStorage.setItem('setInvigilate', JSON.stringify(data))
                this.$router.push({name: 'invigilateDetail'})
            },
        }
    }
</script>
<style scoped>
	.cell .el-button {
		margin-left: 0;
		margin-right: 10px;
		margin-top: 10px;
	}
</style>
